<div class="proposal-list-wrapper h-100 w-100" style="background: #F7FAF7;">

    <div class="proposal-inner h-100 m-0 overflow-hidden">
        <ng-container>
        <div class="container-xl h-100  overflow-hidden py-3 px-4"
        [ngClass]="{'proposal-list': totalRecords && totalRecords > 10}">
        <div class="proposal-header d-flex justify-content-between align-items-center mb-4">
            <div >
               
                <h4 class="fs-20 fw-600 mb-1" style="font-size: 20px;font-weight: 600;">
                    Disputes
                </h4>
                <p class="fs-14 fw-500 m-0">
                    Total {{totalRecords}} Disputes
                </p>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex search-bg input_field p-0 overflow-hidden me-3">
                    <span class="d-flex justify-content-center align-items-center ms-2 search-bg">
                        <img src="assets/images/icons/search-icon.svg" alt="">
                    </span>
                    <div>
                        <input type="text" class="search-bg input_field py-2 pe-3 flex-fill m-0 border-0 border-end right-tb-border remove "
                            placeholder="Search" [(ngModel)]="search_string"
                            (keydown.enter)="search_string.trim() ? getcontractList() : null"
                            (ngModelChange)="!search_string ? getcontractList() : null">
                        <img src="assets/images/icons/cross-icon.svg" alt="" class="cursor px-2"
                            (click)="search_string = ''; getcontractList()" *ngIf="search_string">
                    </div>
                </div>
            
                <div class="dropdown">
                    <div class="selected-option d-flex align-items-center fw-600 py-2 px-3 border radius-8 bg-white cursor"
                        id="dropdownMenuClickableInside" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                        {{selectedType.value == 0 ? 'All' : selectedType.key}}
                        <img src="assets/images/icons/down-arrow.svg" alt="" class="ms-2" style="height: 16px;">
                    </div>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li class="fs-16 fw-500 px-3 py-1 d-flex justify-content-between align-items-center dropdown-item remove-border cursor"
                            *ngFor="let option of typesFilter" (click)="selectOption(option,'type')">
                            {{option.key}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
                <div class="proposal-body overflow-auto hide-scroll-bar">
                    <ng-container *ngIf="contractData && contractData.length">
                        <div class="proposal-box border radius-8 mb-4"
                            *ngFor="let proposal of contractData;let i = index">
                            <div class="proposal-detail-left bg-white p-3 radius-8 ">
                                <!-- <div class="d-flex align-items-center justify-content-between w-100"> -->
                                    <p class="fs-12 fw-600 cursor mxw-200" style="width: 200px;font-size: 12px;" (click)="redirectOnDetail(proposal)">
                                        Account ID: {{proposal.payment_id}}
                                    </p>
                                <!-- </div> -->
                                <div class="row cursor" [routerLink]="['/app/disputes/details']" [queryParams]="proposal.contract_id ? { contract_id: proposal.contract_id } : { split_req_id: proposal.split_req_id }">
                                    <div class="col-7">
                                        <div class="d-flex align-items-center gap-3">
                                            <!-- <img src="assets/images/icons/profile_placeholder.png" alt="" 
                                                                    class="ZI-2 hw-80 rounded-circle borfde mb-3 cursor mt-2 border-white"> -->
                                            <span
                                                [ngStyle]="{'background': _shared.dynamicColorBgStyle[i % _shared.dynamicColorBgStyle.length].bg,'color':_shared.dynamicColorBgStyle[i % _shared.dynamicColorBgStyle.length].color}"
                                                class="ZI-2 hw-56 -mx-auto d-flex align-items-center justify-content-center rounded-circle borfde  cursor  border-white fs-22 fw-700" style="font-weight: 600;">{{proposal.initials}}
                                            </span>
                                            <span>
                                                <h4 class="fs-18 fw-800 m-0 mb-1 text-capitalize" style="font-size: 18px;font-weight: 700;">
                                                    {{proposal.patient_name}}
                                                </h4>
                                                <p class="fs-14 fw-400 m-0 grey-text" style="font-size: 14px;">
                                                    {{proposal.patient_email}} <span class="vr mx-2" *ngIf="proposal.patient_mobile_country_code && proposal.patient_mobile_country_code && proposal.patient_mobile"></span><span *ngIf="proposal.patient_mobile_country_code && proposal.patient_mobile_country_code && proposal.patient_mobile"> {{proposal.patient_mobile_country_code}} <input
                                                        type="text" [ngModel]="proposal.patient_mobile" [mask]="mask"
                                                        class="pe-none grey-text bg-transparent border-0"></span>
                                                </p>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-5 d-flex align-items-center justify-content-between">
                                        
                                    <div class="d-flex align-items-center">
                                       
                                            <span>
                                                <h4 class="fs-12 fw-400 mb-1 grey-text" style="font-size: 12px;">
                                                    Disputed Date
                                                </h4>
                                                <p class="fs-16 fw-700 m-0 dark-grey" style="font-size: 16px;">
                                                    {{proposal.last_dispute_date | date:"MM/dd/yyyy" : timezone}}
                                                </p>
                                            </span>
                                           
                                            
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <span class="mnw-175 ps-5">
                                            <h4 class="fs-12 fw-400 mb-1 grey-text" style="font-size: 12px;">
                                                Status
                                            </h4>
                                            <p class="prposal-status fs-16 fw-600 m-0" style="font-size: 16px;"
                                                [ngClass]="proposal.status.code == 1 ? 'new' :
                                                proposal.status.code == 2 ? 'pending' : proposal.status.code == 3 ?'submitted' :   proposal.status.code == 4? 'need-doc':proposal.status.code == 5 ? 'verified':''  ">

                                                {{proposal.status.status }}
                                            </p>
                                        </span>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <button [routerLink]="['/app/disputes/details'
                                                              ]"
                                                [queryParams]="proposal.contract_id ? { contract_id: proposal.contract_id } : { split_req_id: proposal.split_req_id }"
                                                class="border  p-1 px-3 bg-white fs-14 fw-700 m-0 radius-16 black-44" style="font-size: 14px;font-weight: 600
                                                ;">
                                                View Details
                                            </button>
                                    </div>
                                    
                                </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="!contractData || (contractData && !contractData.length)"
                        class="h-100 d-flex justify-content-center align-items-center bg-white radius-16 border"
                        style="max-height: calc(100% -  20px);">
                        <span class="text-center mxw-450">
                            <img src="assets/images/icons/no_contract.svg" alt="" class="mb-5">
                            <h4 class="fs-32 fw-700 m-0 mb-3">
                                No Data Found
                            </h4>
                            <p class="fs-16 fw-600 m-0">
                                Sorry, we couldn't find any matching data.
                                Try adjusting your filters or check back later for updates.
                            </p>
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="w-100 d-flex hw-65 justify-content-between align-items-center px-4 py-3 container-xl"
            *ngIf="totalRecords && totalRecords > 10">
            <p class="fs-14 fw-500 m-0">
                Showing {{ (currentPage - 1) * 10 + 1 }}-{{ currentPage * 10 > totalRecords ? totalRecords :
                currentPage * 10 }}
                out of {{totalRecords}} contracts
            </p>
            <pagination [totalItems]="totalRecords" [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)"
                previousText="Prev"></pagination>
        </div>
    </div>
</div>
<ng-template #noDataFound>
    <div class="h-100 w-100 d-flex align-items-center justify-content-center ">
        <div class="text-center p-5 radius-16 container-xl ">
            <img src="assets/images/icons/no-contracts.png" alt="" class="mb-4">
            <ng-container *ngIf="!(contractData && contractData.length)">
                <h4 class="fs-32 fw-700 mb-3">
                    {{searchString && searchString.length ? 'No disputes found' : 'No disputes raised yet'}}
                </h4>
                <p *ngIf="!searchString || (searchString && !searchString.length)"
                    class="fs-16 fw-500 mb-4 mxw-450 mx-auto">
                    It appears that there are no disputes available at the moment.
                </p>
                <!-- <button *ngIf="!search_string || (search_string && !search_string.length)" class="btn btn-secondary" [routerLink]="'/app/finance/finance-customer'">
            Create Your First Contract
          </button> -->
            </ng-container>
        </div>
    </div>
</ng-template>